import React from 'react'
import LoadingIcon from 'components/LoadingIcon'

function Loading() {
  return (
    <div className="loading-screen d-flex h-100 w-100 justify-content-center align-items-center">
      <LoadingIcon size="3x" />
    </div>
  )
}

export default Loading
